import {createRoute} from "@tanstack/react-router"
import {rootRoute} from "@/routing/router"
import ProgramChanges from "@/components/changelog/program-changes"
import ChangelogProvider from "@/components/changelog/context/changelog-provider"

export const publicChangelogRoute = createRoute({
    path: "/program-changes",
    getParentRoute: () => rootRoute,
    component: () => <ChangelogProvider withAuth={false}>
        <ProgramChanges/>
    </ChangelogProvider>
})
export const publicRefKeyChangelogRoute = createRoute({
    path: "/program-changes/$refKey",
    getParentRoute: () => rootRoute,
    component: () => <ChangelogProvider withAuth={false}>
        <ProgramChanges/>
    </ChangelogProvider>
})
